import * as addGood from '../services/addGood';

export default {
  namespace: 'addGood',

  state: {
    //用于获取编辑状态下后端给的图片预览地址列表
    imgUrlList: [],
  },

  effects: {
    //单个商品详情
    *getGoodDetail({ payload: { values }, callback }, { call, put }) {
      const response = yield call(addGood.getGoodDetail, values);
      const { images, coverImage } = response.data;
      yield put({
        type: 'save',
        payload: {
          goodDetail: response?.data,
          imgUrlList: images,
          coverImgUrl: coverImage, //编辑时后端给图片路径
        },
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //新增商品
    *addGood({ payload: { values }, callback }, { call, put }) {
      const response = yield call(addGood.addGood, values);
      yield put({
        type: 'save',
        payload: {},
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
    //修改商品
    *updateGood({ payload: { values }, callback }, { call, put }) {
      const response = yield call(addGood.updateGood, values);
      yield put({
        type: 'save',
        payload: {},
      });
      if (callback && typeof callback === 'function') {
        return callback(response);
      }
    },
  },

  reducers: {
    save(state, action) {
      return { ...state, ...action.payload };
    },
  },

  subscriptions: {
    setup({ history, dispatch }) {
      return history.listen((props) => {
        if (
          [
            '/goods/goods_list/goods_add',
            '/goods/goods_list/goods_edit',
            '/goods/goods_list/goods_detail',
          ].includes(props.pathname)
        ) {
          dispatch({
            type: 'save',
            payload: {
              goodDetail: {},
              imgUrlList: [],
              coverImgUrl: '',
            },
          });
        }
      });
    },
  },
};
